import { getDisplayDate } from 'src/utils/dateUtils';
import {
    getPriceInNumberDataType,
    noPriceErrorMsg,
    ACCOUNT_OWNED_REQUIRED_MSG,
} from './dataModificaionUtil';
import { setCurrencyFormat } from 'src/utils/util';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { MANDATORY, VISIBLE } from 'src/constants/appConstants';

import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const getModifiedButtonVisibilities = (
    myCaseResourceType,
    footerButtonStatuses,
    btn1,
    btn2,
    fromProgressBar
) => {
    let modifiedButtonStatuses = [...footerButtonStatuses];
    if (fromProgressBar) {
        modifiedButtonStatuses = modifiedButtonStatuses.map((x) =>
            x.btnName !==
                i18n.t('reportUsage.reportUsageFooterbuttons.cancelButton') &&
            x.btnName !== i18n.t('reportUsage.saveExit')
                ? { ...x, btnVisibility: false }
                : x
        );
    }
    const btn1Idx = modifiedButtonStatuses.findIndex((x) => x.btnName === btn1);
    if (btn1Idx >= 0) {
        modifiedButtonStatuses[btn1Idx].btnVisibility = false;
    }
    const saveExitBtnIdx = modifiedButtonStatuses.findIndex(
        (x) => x.btnName === i18n.t('reportUsage.saveExit')
    );
    if (saveExitBtnIdx >= 0) {
        modifiedButtonStatuses[saveExitBtnIdx].btnVisibility =
            btn2 === i18n.t('orders.orderListFilters.applyButton') ||
            myCaseResourceType === 'reportPayment'
                ? false
                : true;
    }
    const btn2Idx = modifiedButtonStatuses.findIndex((x) => x.btnName === btn2);
    if (btn2Idx >= 0) {
        modifiedButtonStatuses[btn2Idx].btnVisibility = true;
    }
    return modifiedButtonStatuses;
};

export const getProgressBarStateOnLoad = (usageDetails) => {
    const progBarInitialStateForUsage = {
        Record: {
            label: 'Record',
            displayLabel: i18n.t('reportUsage.progressBar.recordTitle'),
            progress: 0,
            current: true,
            done: false,
        },
        Replen: {
            label: 'Replen',
            displayLabel: i18n.t('reportUsage.progressBar.replen'),
            progress: 50,
            current: false,
            done: false,
        },
        Procedure: {
            label: 'Procedure',
            displayLabel: i18n.t('reportUsage.progressBar.procedure'),
            progress: 0,
            current: false,
            done: false,
        },
        Submit: {
            label: 'Submit',
            displayLabel: i18n.t('reportUsage.progressBar.submit'),
            progress: 0,
            current: false,
            done: false,
        },
    };
    const progressBarState = { ...progBarInitialStateForUsage };
    if (
        usageDetails &&
        usageDetails.hrefId?.length > 0 &&
        usageDetails.products?.length > 0 &&
        usageDetails.products.every(
            (item) =>
                (item.usedQuantity || item.otherQuantity) &&
                item.unitPrice?.length > 0 &&
                (item.isSerialRequired
                    ? item.lotSerialNumber?.length > 0
                    : true)
        )
    ) {
        progressBarState['Record'].current = true;
        progressBarState['Record'].done = true;
        if (
            usageDetails.products.some((item) => item.isReplenish) ||
            (usageDetails.products.every((item) => !item.isReplenish) &&
                usageDetails.procedure &&
                Object.keys(usageDetails.procedure).length >= 4)
        ) {
            progressBarState['Replen'].progress = 100;
            progressBarState['Replen'].done = true;
            progressBarState['Replen'].current = false;
            if (
                usageDetails.physicianId?.length > 0 &&
                usageDetails.procedureCode?.length > 0 &&
                usageDetails.procedure &&
                Object.keys(usageDetails.procedure).length >= 4 &&
                usageDetails.procedure.additionProcedure &&
                Object.keys(usageDetails.procedure.additionProcedure).length >=
                    3
            ) {
                progressBarState['Procedure'].progress = 100;
                progressBarState['Procedure'].done = true;
                progressBarState['Procedure'].current = false;
                progressBarState['Submit'].progress = 100;
            }
        }
    }
    return progressBarState;
};

export const calculateDiscountPercentage = (originalPrice, adjustedPrice) => {
    const discount =
        originalPrice > 0 ? (originalPrice - adjustedPrice) / originalPrice : 0;
    return (discount * 100).toFixed(2);
};

export const checkIfValidQuantities = (qty) => {
    const usedQty = qty.used || qty.Used || qty.usedQuantity;
    const otherQty = qty.other || qty.Other;
    if (
        usedQty &&
        (typeof usedQty === 'string' || typeof usedQty === 'number')
    ) {
        return parseInt(usedQty) > 0;
    } else if (
        otherQty &&
        (typeof otherQty === 'string' || typeof otherQty === 'number')
    ) {
        return parseInt(otherQty) > 0;
    } else if (usedQty === true || otherQty === true) {
        return true;
    } else {
        return false;
    }
};

const isValidItemMessage = (item) =>
    !item.isInvalidItemMsg ||
    (item.isInvalidItemMsg === ACCOUNT_OWNED_REQUIRED_MSG &&
        item.accountOwned === true);

export const checkIfValidPricedItems = (
    itemTableData,
    isForPriceOverride,
    doNotValidateQty
) =>
    itemTableData &&
    itemTableData.length > 0 &&
    itemTableData.every(
        (item) =>
            isValidItemMessage(item) &&
            item.basePrice &&
            getPriceInNumberDataType(item.basePrice) >= 0 &&
            (item.lotSerial
                ? item.lotSerial.length > 0 &&
                  item.lotSerial.every(
                      (qty) =>
                          (isForPriceOverride
                              ? true
                              : !qty.isInvalidLotSerialMsg) &&
                          !qty.isInvalidQtyMsg &&
                          (doNotValidateQty
                              ? true
                              : checkIfValidQuantities(qty))
                  )
                        : isValidItemMessage(item) &&
                  (item.usedQuantity || item.otherQuantity) &&
                  (parseInt(item.usedQuantity) > 0 ||
                      parseInt(item.otherQuantity) > 0 ||
                      item.usedQuantity === true ||
                      item.otherQuantity === true) &&
                  !item.isInvalidQtyMsg &&
                  !item.noItemInBundleErr) &&
            (item.isBundleItem
                ? !item.noItemInBundleErr &&
                  item.children?.length > 0 &&
                  item.children.every(
                      (child) =>
                          !child.isInvalidItemMsg &&
                          Object.prototype.hasOwnProperty.call(
                              child,
                              'basePrice'
                          ) &&
                          //child.hasOwnProperty('basePrice') &&
                          child.lotSerial &&
                          child.lotSerial.length > 0 &&
                          child.lotSerial.every(
                              (qty) =>
                                  (isForPriceOverride
                                      ? true
                                      : !qty.isInvalidLotSerialMsg) &&
                                  !qty.isInvalidQtyMsg &&
                                  (doNotValidateQty
                                      ? true
                                      : checkIfValidQuantities(qty))
                          )
                  )
                : !item.children)
    );

export const checkIfValidPricedRPItems = (itemTableData) =>
    itemTableData &&
    itemTableData.length > 0 &&
    itemTableData.every(
        (item) =>
            !item.isInvalidItemMsg &&
            (item.usedQuantity || item.otherQuantity) &&
            (parseInt(item.usedQuantity) > 0 ||
                parseInt(item.otherQuantity) > 0 ||
                item.usedQuantity === true ||
                item.otherQuantity === true) &&
            !item.isInvalidQtyMsg &&
            !item.noItemInBundleErr &&
            item.unitPrice &&
            (item?.lotSerialUnknownApplicable && (item?.isSerialRequired ||item?.isBatchRequired) ? item?.lotSerialUnknown : true) &&
            getPriceInNumberDataType(item.unitPrice) >= 0 &&
            (item.isAdditionalCartEntry ? item.isPriced : true) &&
            (item.isBundleItem
                ? item.bundleItem?.length > 0 &&
                  item.bundleItem.every(
                      (child) =>
                          !child.isInvalidItemMsg &&
                          !child.isInvalidQtyMsg &&
                          child.quantity &&
                          parseInt(child.quantity) > 0 &&
                          (child.isAdditionalCartChild ? child.isPriced : true)
                  )
                : !(item.bundleItem && item.bundleItem.length > 0))
    );

export const validateReportPaymentItem = (itemTableData, initialLoad) => {
    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every((item) => {
            return (
                !item.isInvalidItemMsg &&
                getPriceInNumberDataType(item.unitPrice) >= 0 &&
                (!item.isPoImageError || initialLoad) &&
                !item.isInvalidLotSerialMsg &&
                !item.isInvalidQtyMsg &&
                (parseInt(item.usedQuantity) > 0 ||
                    parseInt(item.otherQuantity) > 0 ||
                    item.usedQuantity === true ||
                    item.otherQuantity === true ||
                    item.isPriceUpdated) &&
                (item.isBundleItem
                    ? item.bundleItem?.length > 0 &&
                      item.bundleItem.every(
                          (child) =>
                              !child.isInvalidItemMsg &&
                              !child.isInvalidLotSerialMsg &&
                              !child.isInvalidQtyMsg &&
                              child.quantity != undefined &&
                              parseInt(child.quantity) > 0 &&
                              child.description != ''
                      )
                    : !(item.bundleItem && item.bundleItem.length > 0))
            );
        })
    );
};

export const getTotalUsedQuantity = (lotSerialArr) => {
    const usedQuantityArr =
        lotSerialArr &&
        Array.isArray(lotSerialArr) &&
        lotSerialArr.length > 0 &&
        lotSerialArr
            .map((x) => {
                const usedQty = x ? x.used || x.Used : 0;
                return usedQty === true ? 1 : parseInt(usedQty);
            })
            .filter((y) => !isNaN(parseInt(y)));
    return usedQuantityArr && usedQuantityArr.length > 0
        ? usedQuantityArr.reduce((a, b) => a + b, 0)
        : null;
};

export const getTotalUsedTissueItemQuantity = (lotSerialArr) => {
    const usedQuantity =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr.filter((x) => x && (x.used === true || x.Used === true));
    return usedQuantity && usedQuantity.length;
};

export const getTotalOtherTissueItemQuantity = (lotSerialArr) => {
    const otherQuantity =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr.filter((x) => x && (x.other === true || x.Other === true));
    return otherQuantity && otherQuantity.length;
};

export const getTotalOtherQuantity = (lotSerialArr) => {
    const otherQuantityArr =
        lotSerialArr &&
        lotSerialArr.length > 0 &&
        lotSerialArr
            .map((x) => {
                const otherQty = x ? x.other || x.Other : 0;
                return otherQty === true ? 1 : parseInt(otherQty);
            })
            .filter((y) => !isNaN(parseInt(y)));
    return otherQuantityArr && otherQuantityArr.length > 0
        ? otherQuantityArr.reduce((a, b) => a + b, 0)
        : null;
};

export const getTotalQuantity = (lotSerialArr) => {
    let totalQuantity = 0;
    if (lotSerialArr && lotSerialArr.length > 0) {
        const usedQuantity = getTotalUsedQuantity(lotSerialArr)
            ? getTotalUsedQuantity(lotSerialArr)
            : 0;
        const otherQuantity = getTotalOtherQuantity(lotSerialArr)
            ? getTotalOtherQuantity(lotSerialArr)
            : 0;
        totalQuantity = usedQuantity + otherQuantity;
    }
    return totalQuantity;
};

const getStoredCurrency = () => {
    const code = localStorage.getItem('currencyISOCode');
    return code && code !== 'undefined' ? code : 'USD';
};

export const priceFormatObj = {
    style: 'currency',
    currency: getStoredCurrency(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export const getTotalExtendedPrice = (adjBasePrice, lotSerialArr, qtyType) => {
    let extendedPrice = setCurrencyFormat(0),
        quantity = 0;
    if (qtyType === 'used') {
        quantity = getTotalUsedQuantity(lotSerialArr);
    } else if (qtyType === 'other') {
        quantity = getTotalOtherQuantity(lotSerialArr);
    } else if (qtyType === 'total') {
        quantity = getTotalQuantity(lotSerialArr);
    }
    if (adjBasePrice && quantity > 0) {
        extendedPrice = setCurrencyFormat(
            getPriceInNumberDataType(adjBasePrice) * quantity
        );
    }
    return adjBasePrice ? extendedPrice : '';
};
export const getTotalExtendedPriceRP = (adjBasePrice, qty, qtyType) => {
    let extendedPrice = setCurrencyFormat(0),
        quantity = 0;
    adjBasePrice = getPriceInNumberDataType(adjBasePrice);
    qty = parseInt(qty === true ? 1 : qty);
    if (qtyType === 'used') {
        const uQty = qty;
        quantity = uQty;
    } else if (qtyType === 'other') {
        const oQty = qty;
        quantity = oQty;
    }
    if (adjBasePrice && quantity > 0) {
        extendedPrice = setCurrencyFormat(adjBasePrice * quantity);
    }
    return adjBasePrice != undefined &&
        adjBasePrice != null &&
        typeof adjBasePrice === 'number'
        ? extendedPrice
        : '';
};

export const flattenLotSerialArrayOfArrays = (
    filterType,
    items,
    productCFN
) => {
    if (filterType === 'nonTissue') {
        return items
            .filter((item) => item.salesOrg !== 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'tissue') {
        return items
            .filter((item) => item.salesOrg === 'S030')
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'accOwned') {
        return items
            .filter((item) => item.accountOwned)
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    } else if (filterType === 'serialIssued' && productCFN) {
        return items
            .filter(
                (item) =>
                    item.cfn === productCFN &&
                    !item.isLot &&
                    item.isSerialRequired
            )
            .reduce(
                (previousValue, currentValue) =>
                    previousValue.concat(currentValue.lotSerial),
                []
            );
    }
    return [];
};



export const isPriceOverrideApplyBtnDisabled = (
    priceOverrideReason,
    priceOverrideTableData,
    pricingNotes,
    priceOverrideReasonMandatoryUsage,  
    priceOverrideReasonVisibilityUsage ,                              
    priceOverrideCommentsMandatoryUsage,
    priceOverrideCommentsVisibilityUsage
) => {

    const tableData = Array.isArray(priceOverrideTableData)
        ? priceOverrideTableData
        : [];

    // Backward compatibility: some callers/tests pass boolean flags.
    const isReasonVisible =
        priceOverrideReasonVisibilityUsage === VISIBLE;
    const isCommentsVisible =
        priceOverrideCommentsVisibilityUsage === VISIBLE;

    const isReasonMandatory =
        isReasonVisible &&
        (
            priceOverrideReasonMandatoryUsage === MANDATORY);
    const isCommentsMandatory =
        isCommentsVisible &&
        (
            priceOverrideCommentsMandatoryUsage === MANDATORY);

    const reasonProvided =
        !isReasonMandatory ||
        (priceOverrideReason && priceOverrideReason.length > 0);
    const commentsProvided =
        !isCommentsMandatory || (pricingNotes && pricingNotes.length > 0);

    // Normalize local flags used elsewhere in this file.
    tableData.forEach((item) => {
        if (
            item?.overrideUnitPrice !== null &&
            item?.overrideUnitPrice !== undefined &&
            item?.overrideUnitPrice !== ''
        ) {
            item.overrideUnitPriceApplied = true;
            // Keep both spellings since different parts of the codebase reference both.
            item.overridenUnitPriceApplied = true;
        }
    });

    const hasAnyAdjustedQtyPrice = tableData.some(
        (item) => item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice
    );
    const hasAnyAdjustmentOrOverrideApplied = tableData.some(
        (item) =>
            item.adjustedOtherQtyPrice ||
            item.adjustedUsedQtyPrice ||
            item.overridenUnitPriceApplied ||
            item.overrideUnitPriceApplied
    );
    const hasAnyValidAdjustment = tableData.some(
        (item) =>
            !item.invalidOtherQtyAdjBasePriceMsg &&
            !item.invalidUsedQtyAdjBasePriceMsg &&
            (item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice)
    );
    const hasAnyInvalidAdjustment = tableData.some(
        (item) =>
            item.invalidOtherQtyAdjBasePriceMsg ||
            item.invalidUsedQtyAdjBasePriceMsg
    );
    const hasSomeNonInvalidRow = tableData.some(
        (item) =>
            !item.invalidOtherQtyAdjBasePriceMsg &&
            !item.invalidUsedQtyAdjBasePriceMsg
    );

    const isAnyOverrideApplied = tableData.some((item) => item.isOverrideApplied);
    if (isAnyOverrideApplied) {
        const shouldDisableBecauseProvidedButNoChange =
            ((isReasonMandatory && priceOverrideReason?.length > 0) ||
                (isCommentsMandatory && pricingNotes?.length > 0)) &&
            !hasAnyAdjustedQtyPrice;

        const shouldDisableBecauseMandatoryMissing = hasAnyValidAdjustment
            ? !(reasonProvided && commentsProvided)
            : false;

        return (
            shouldDisableBecauseProvidedButNoChange ||
            shouldDisableBecauseMandatoryMissing ||
            hasAnyInvalidAdjustment
        );
    }

    return !(
        reasonProvided &&
        commentsProvided &&
        hasAnyAdjustmentOrOverrideApplied &&
        hasSomeNonInvalidRow
    );
};
export const checkIfValidProductsInRecordScreen = (
    validProducts,
    itemTableData,
    patientDetails,
    myCaseResourceType,
    patientIdMandatory
) => {
    const validProductsCfn = validProducts.map((x) => x.productCFN);
    return myCaseResourceType === 'reportPayment'
        ? itemTableData &&
              itemTableData.length > 0 &&
              itemTableData.every((item) =>
                  isValidItemMessage(item) &&
                  validProductsCfn.includes(item.cfn) &&
                  item.isBundleItem
                      ? item.bundleItem &&
                        item.bundleItem.every(
                            (child) =>
                                !child.isInvalidItemMsg &&
                                validProductsCfn.includes(child.productCFN)
                        )
                      : !item.bundleItem
              ) &&
              checkIfValidPricedRPItems(itemTableData) &&
              (patientDetails.hrefId !== ''
                  ? patientDetails.hrefId?.length > 0
                  : true)
        : itemTableData &&
              itemTableData.length > 0 &&
              itemTableData.every((item) =>
                  !item.isInvalidItemMsg &&
                  validProductsCfn.includes(item.cfn) &&
                  item.lotSerial?.every(
                      (x) => !x.isInvalidLotSerialMsg && !x.isInvalidQtyMsg
                  ) &&
                  item.isBundleItem
                      ? item.children &&
                        item.children.every(
                            (child) =>
                                !child.isInvalidItemMsg &&
                                validProductsCfn.includes(child.cfn) &&
                                child.lotSerial.every(
                                    (x) =>
                                        !x.isInvalidLotSerialMsg &&
                                        !x.isInvalidQtyMsg
                                )
                        )
                      : !item.children
              ) &&
              checkIfValidPricedItems(itemTableData, false, false) &&
              patientDetails &&
              (patientIdMandatory ? patientDetails.hrefId?.length > 0 : true);
};
export const checkIfValidData = (itemTableData) => {
    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every(
            (item) =>
                isValidItemMessage(item) &&
                item.lotSerial?.every(
                    (x) =>
                        !x.isInvalidLotSerialMsg &&
                        !x.isInvalidQtyMsg &&
                        (x.used > 0 || x.other > 0)
                ) &&
                (item.isBundleItem
                    ? item.children &&
                      item.children.every(
                          (child) =>
                              !child.isInvalidItemMsg &&
                              child.lotSerial.every(
                                  (x) =>
                                      !x.isInvalidLotSerialMsg &&
                                      !x.isInvalidQtyMsg
                              )
                      )
                    : !item.children)
        ) &&
        checkIfValidPricedItems(itemTableData, false, false)
    );
};

export const checkIfValidReportPaymentData = (validProducts, itemTableData) => {
    const validProductsCfn = validProducts.map((x) => x.productCFN || x.cfn);
    return (
        itemTableData &&
        itemTableData.length > 0 &&
        itemTableData.every((item) => {
            return (
                !item.isInvalidItemMsg &&
                !item.isInvalidQtyMsg &&
                validProductsCfn.includes(item.cfn || item.productCFN) &&
                !item?.isInvalidLotSerialMsg?.length > 0 &&
                (item.isBundleItem
                    ? item.bundleItem &&
                      item.bundleItem.every(
                          (child) =>
                              !child.isInvalidItemMsg &&
                              !child.isInvalidQtyMsg &&
                              validProductsCfn.includes(child.productCFN) &&
                              !child.isInvalidLotSerialMsg
                      )
                    : !item.isBundleItem)
            );
        })

        //need to Ask
        // checkIfValidPricedItems(itemTableData) &&
        // patientDetails &&
        // patientDetails.hrefId.length > 0
    );
};

export const getPatientDetailsInDraftOrder = (
    patientDetails,
    PatientDetailsVisibility,
    countryCode
) => {
    const isVisible = (field) => {
        return (
            (Array.isArray(PatientDetailsVisibility) ||
                typeof PatientDetailsVisibility === 'string') &&
            PatientDetailsVisibility.includes(field)
        );
    };

    return {
        hrefId: patientDetails.hrefId
            ? isVisible('href')
                ? patientDetails.hrefId
                : ''
            : '',
        patientDOB: patientDetails.patientDOB
            ? getDisplayDate(patientDetails.patientDOB, 'YYYY-MM-DD')
            : '',
        patientFirstName: patientDetails.patientFirstName
            ? isVisible('name')
                ? patientDetails.patientFirstName
                : ''
            : '',
        patientLastName: patientDetails.patientLastName
            ? isVisible('name')
                ? patientDetails.patientLastName
                : ''
            : '',
        patientSex: patientDetails.patientSex ? patientDetails.patientSex : '',
        patientSalutation: patientDetails.patientSalutation
            ? patientDetails.patientSalutation
            : '',
    };
};

const generateSingleItemObj = (
    item,
    replenData,
    qtyArr,
    lotSerialObj,
    isChildItem,
    exisitingFormObject
) => {
    const isSerialUnknown = item?.lotSerial?.some(
        (item) => item?.lotSerialUnknown
    );
    const lotSerialData = item?.lotSerial;
    const qtyType = qtyArr && qtyArr[0] && qtyArr[0].toLowerCase();
    const singleItemObj = { productCFN: item.cfn, isReplenish: false };
    if (item.unqId) {
        singleItemObj.unqId = item.unqId;
    }
    if (item.scannedGTIN) {
        singleItemObj.scannedGTIN = item.scannedGTIN;
    }
    if (item.salesOrg) {
        singleItemObj.salesOrg = item.salesOrg;
    }
    if (item.description) {
        singleItemObj.description = item.description;
    }
    if (item.uom) {
        singleItemObj.uom = item.uom;
    }
    if (lotSerialObj?.Serial) {
        singleItemObj.lotSerialNumber = lotSerialObj.Serial;
    }
    if (item.isBundleItem) {
        singleItemObj.isBundleItem = item.isBundleItem;
        singleItemObj.isBundleExpanded = true;
    }
    if (item.isUnidRodItem) {
        singleItemObj.isUnidRodItem = item.isUnidRodItem;
    }
    if ((qtyType === 'used' || qtyType === 'other') && qtyArr[1]) {
        singleItemObj[
            isChildItem
                ? 'quantity'
                : qtyType === 'other'
                ? 'otherQuantity'
                : 'usedQuantity'
        ] = qtyArr[1] === true ? '1' : qtyArr[1];
    }
    if (qtyType === 'used' && lotSerialObj?.usedQtyPayment) {
        singleItemObj.payment = lotSerialObj.usedQtyPayment;
    }
    if (qtyType === 'other' && lotSerialObj?.otherQtyPayment) {
        singleItemObj.payment = lotSerialObj.otherQtyPayment;
    }
    singleItemObj.isAccountOwned = item.accountOwned
        ? item.accountOwned
        : false;
    singleItemObj.lotSerialUnknown = isSerialUnknown ? isSerialUnknown : '';
    singleItemObj.lotSerial = lotSerialData ? lotSerialData : [];

    if (!isChildItem) {
        singleItemObj.isPriceNotAvailable =
            item.exclusionStatus === noPriceErrorMsg ||
            item.isPriceNotAvailable;
        singleItemObj.isAdditionalCartEntry = item.isAdditionalCartEntry
            ? item.isAdditionalCartEntry
            : false;
        singleItemObj.lotSerialUnknown = isSerialUnknown ? isSerialUnknown : '';
        if (item.basePrice) {
            singleItemObj.unitPrice = getPriceInNumberDataType(
                item.basePrice
            ).toFixed(2);
        }
        if (qtyType === 'used' && item.adjustedUsedQtyPrice) {
            singleItemObj.overrideUnitPrice = item.adjustedUsedQtyPrice;
        } else if (qtyType === 'other' && item.adjustedOtherQtyPrice) {
            singleItemObj.overrideUnitPrice = item.adjustedOtherQtyPrice;
        }
    }
    if (exisitingFormObject?.products?.length > 0) {
        const existingItem = exisitingFormObject?.products?.filter((existing) => {
            const isQtyflag = Object.keys(existing).includes(
                `${qtyType}Quantity`
            );
            return (
                existing.productCFN === item.cfn &&
                existing.lotSerial?.filter(
                    (x) => x.Serial === lotSerialObj?.Serial
                )?.length > 0 &&
                existing.payment &&
                singleItemObj?.lotSerialNumber === existing?.lotSerialNumber &&
                Object.keys(existing.payment).length > 0 &&
                isQtyflag
            );
        });
        if (existingItem?.length > 0) {
            // Merge existing payment (from saved draft) with newly added payment (from current lotSerialObj)
            // Prefer the newly added values in singleItemObj.payment if both exist
            // Only merge if singleItemObj.payment exists; if undefined (deleted), keep it undefined
            singleItemObj.payment = singleItemObj.payment
                ? {
                      ...(existingItem[0]?.payment || {}),
                      ...singleItemObj.payment,
                  }
                : undefined;
            if (existingItem[0].isAdditionalCartEntry) {
                singleItemObj.isAdditionalCartEntry =
                    existingItem[0]?.isAdditionalCartEntry;
            }
        }
        const getAditionalCartEntry = exisitingFormObject?.products?.filter(
            (existing) =>
                existing.productCFN === item.cfn &&
                existing.isAdditionalCartEntry
        );
        if (getAditionalCartEntry?.length > 0) {
            singleItemObj.isAdditionalCartEntry =
                getAditionalCartEntry[0]?.isAdditionalCartEntry;
        }
    }
    const isValidQty =
        (isChildItem && singleItemObj.quantity) ||
        singleItemObj.usedQuantity ||
        singleItemObj.otherQuantity;
    if (
        !item.accountOwned &&
        replenData &&
        replenData.length > 0 &&
        replenData.map((x) => x.cfn).includes(item.cfn) &&
        isValidQty
    ) {
        const replenItemIdx = replenData.findIndex((x) => x.cfn === item.cfn);
        if (replenItemIdx >= 0 && replenData[replenItemIdx].shippingDetails) {
            singleItemObj.isReplenish = true;
            const shippingDetails = replenData[replenItemIdx].shippingDetails;
            const { transferRecipient } = shippingDetails;
            singleItemObj.replenishmentDetails = {};
            if (
                replenData[replenItemIdx].newReplenQty ||
                replenData[replenItemIdx].replenQty
            ) {
                singleItemObj.replenishmentDetails.replenishQuantity = (
                    replenData[replenItemIdx].newReplenQty ||
                    replenData[replenItemIdx].replenQty
                ).toString();
            }
            if (
                shippingDetails.accountDetails &&
                shippingDetails.accountDetails.accountId
            ) {
                singleItemObj.replenishmentDetails.accountId =
                    shippingDetails.accountDetails.accountId;
            }
            if (
                shippingDetails.shippingAddress &&
                shippingDetails.shippingAddress.shippingAddressId
            ) {
                singleItemObj.replenishmentDetails.shipTo =
                    shippingDetails.shippingAddress.shippingAddressId;
            }
            if (
                shippingDetails.shippingMethod &&
                shippingDetails.shippingMethod.shippingMethodId
            ) {
                singleItemObj.replenishmentDetails.shippingMethodId =
                    shippingDetails.shippingMethod.shippingMethodId;
            }
            if (shippingDetails.attnLine) {
                singleItemObj.replenishmentDetails.attentionLine =
                    shippingDetails.attnLine;
            }
            if (shippingDetails.careOfField) {
                singleItemObj.replenishmentDetails.careOfField =
                    shippingDetails.careOfField;
            }
            if (Object.keys(transferRecipient).length > 0) {
                singleItemObj.replenishmentDetails.transferRecipient =
                    shippingDetails?.transferRecipient?.addressId;
            }
            if (shippingDetails.requestDeliveryDate) {
                singleItemObj.replenishmentDetails.requestDeliveryDate =
                    shippingDetails.requestDeliveryDate;
            }
            if (shippingDetails.surgeryDate) {
                singleItemObj.replenishmentDetails.surgeryDate =
                    shippingDetails.surgeryDate;
            }
            if (shippingDetails.surgeryNumber) {
                singleItemObj.replenishmentDetails.surgeryNumber =
                    shippingDetails.surgeryNumber;
            }
            if (shippingDetails.billToId) {
                singleItemObj.replenishmentDetails.billToId =
                    shippingDetails.billToId;
            }
            if (
                replenData[replenItemIdx].replenishmentDetails &&
                replenData[replenItemIdx].replenishmentDetails.physician
            ) {
                singleItemObj.replenishmentDetails.physicianId =
                    replenData[
                        replenItemIdx
                    ].replenishmentDetails.physician.physicianId;
            }
            if (
                replenData[replenItemIdx].replenishmentDetails &&
                replenData[replenItemIdx].replenishmentDetails.physician
            ) {
                singleItemObj.replenishmentDetails.physicianName =
                    replenData[
                        replenItemIdx
                    ].replenishmentDetails.physician.physicianDisplayName;
            }
        }
    }

    return singleItemObj;
};

const getProductsInDraftOrder = (
    itemTableData,
    replenData,
    exisitingFormObject
) => {
    const productsArr = [];
    itemTableData.forEach((item) => {
        let itemObj = {};
        item.lotSerial &&
            item.lotSerial.forEach((lotSerialObj) => {
                const quantityArr = Object.entries(lotSerialObj).filter(
                    (objArr) => objArr[0] === 'used' || objArr[0] === 'other'
                );
                if (quantityArr?.length === 2) {
                    const usedQtyIdx = quantityArr.findIndex(
                        (x) => x[0] === 'used'
                    );
                    const otherQtyIdx = quantityArr.findIndex(
                        (x) => x[0] === 'other'
                    );
                    if (
                        (!quantityArr[0][1] && !quantityArr[1][1]) ||
                        (quantityArr[usedQtyIdx][1] &&
                            !quantityArr[otherQtyIdx][1])
                    ) {
                        quantityArr.splice(otherQtyIdx, 1);
                    } else if (
                        quantityArr[otherQtyIdx][1] &&
                        !quantityArr[usedQtyIdx][1]
                    ) {
                        quantityArr.splice(usedQtyIdx, 1);
                    }
                }
                if (quantityArr?.length > 0) {
                    quantityArr.forEach((qtyArr) => {
                        itemObj = generateSingleItemObj(
                            item,
                            replenData,
                            qtyArr,
                            lotSerialObj,
                            false,
                            exisitingFormObject
                        );
                        if (Object.keys(itemObj).length > 0)
                            productsArr.push(itemObj);
                    });
                }
            });
        if (item.isBundleItem && item.children && item.children.length > 0) {
            const bundleItemsArr = [];
            item.children.forEach((child) => {
                let childItemObj = {};
                child.lotSerial &&
                    child.lotSerial.forEach((childLotSerial) => {
                        const childQtyArr = Object.entries(
                            childLotSerial
                        ).filter(
                            (objArr) =>
                                objArr[0] === 'Used' || objArr[0] === 'used'
                        );
                        if (childQtyArr && childQtyArr.length > 0) {
                            childQtyArr.forEach((qtyArr) => {
                                childItemObj = generateSingleItemObj(
                                    child,
                                    replenData,
                                    qtyArr,
                                    childLotSerial,
                                    true,
                                    exisitingFormObject
                                );
                                childItemObj.parentCFN =
                                    item.cfn || item.productCFN;
                                childItemObj.parentId = item.unqId;
                                if (Object.keys(childItemObj).length > 0)
                                    bundleItemsArr.push(childItemObj);
                            });
                        }
                    });
            });
            if (bundleItemsArr.length > 0) {
                itemObj.bundleItem = bundleItemsArr;
            }
        }
    });
    return productsArr;
};

export const createRecordAndReplenDraftOrderObj = (
    usageDetails,
    patientDetails,
    itemTableData,
    replenishData,
    myCaseResourceType,
    exisitingFormObject,
    reportUsagePatientDetails,
    countryCode,
    surgeryNumber
) => {
    let draftOrderObj = {};
    if (usageDetails && Object.keys(usageDetails).length > 0) {
        draftOrderObj.myCaseRef = usageDetails.myCaseRef;
        if (usageDetails?.planStatus) {
            draftOrderObj.planStatus = usageDetails?.planStatus;
        }
        if (usageDetails?.unidId) {
            draftOrderObj.unidId = usageDetails?.unidId;
        }
        draftOrderObj.procedureCode = exisitingFormObject.procedureCode
            ? exisitingFormObject.procedureCode
            : usageDetails.procedureCode;
        draftOrderObj.physicianId = exisitingFormObject.physicianId
            ? exisitingFormObject.physicianId
            : usageDetails.physicianId;
        draftOrderObj.isSapSubmission = false;
        draftOrderObj.isReportPayment = myCaseResourceType === 'reportPayment';
    }
    if (patientDetails && Object.keys(patientDetails).length > 0) {
        const patientDetailsObj = getPatientDetailsInDraftOrder(
            patientDetails,
            reportUsagePatientDetails,
            countryCode
        );
        if (Object.keys(patientDetailsObj).length > 0)
            draftOrderObj = { ...draftOrderObj, ...patientDetailsObj };
    }
    if (surgeryNumber) {
        draftOrderObj.surgeryNumber = surgeryNumber ? surgeryNumber : '';
    }
    if (myCaseResourceType != 'reportPayment') {
        const productsArr = getProductsInDraftOrder(
            itemTableData?.length > 0 ? itemTableData : [],
            replenishData,
            exisitingFormObject
        );
        draftOrderObj = {
            ...draftOrderObj,
            products: productsArr?.length > 0 ? productsArr : [],
        };
    }

    return draftOrderObj;
};

const validateBiologicsDetail = (procedureInfoData) => {
    const biologicsUsed = procedureInfoData?.biologicsUsed;
    const biologicsDetail = procedureInfoData?.biologicsDetail;

    if (!biologicsUsed || !Array.isArray(biologicsUsed)) {
        return true;
    }
    
    const medtronicOrCompetitive = biologicsUsed.find(
        (item) => item.code === '02' && item.isSelected
    );
    if (medtronicOrCompetitive) {
        if (
            !biologicsDetail ||
            !Array.isArray(biologicsDetail) ||
            biologicsDetail.length === 0
        ) {
            return false;
        }

        const hasSelection = biologicsDetail.some(
            (item) =>
                item.isMedtronicSelected === true ||
                item.isCompetitiveSelected === true
        );

        return hasSelection;
    }

    return true;
};

export const checkIfValidProcedureData = (
    procedureInfoData,
    isErrorFoundInProcedure = false,
    isErrorFoundInFirstLevel = false,
    cancelReason = null,
    stealthVisibility = {}
) => {
    const isUnidNonUse = cancelReason?.optionId === 'UNID_NON_USE';
    if (isUnidNonUse) {
        return true;
    }

    return Object.entries(procedureInfoData)?.every(([key, value]) => {
        if (isUnidNonUse) {
            return key === 'therapies' ? true : value && value.length > 0;
        }
        if (Array.isArray(value)) {
            if (value[0] === 'ADDITIONAL_PROCEDURE_DATA') {
                return true;
            }

            switch (key) {
                case 'additionalProcedure':
                    return validateAdditionalProcedure(value, stealthVisibility);
                case 'biologicsDetail':
                    return validateBiologicsDetail(procedureInfoData);
                case 'levels':
                case 'levelsData':
                    return !(
                        isErrorFoundInProcedure || isErrorFoundInFirstLevel
                    );
                default:
                    return value.some((x) => x.isSelected);
            }
        }

        if (key === 'procedureConfigFlag' || key === 'biologicsDetail') {
            return true;
        }

        return value && value.length > 0;
    });
};

const validateAdditionalProcedure = (items, stealthVisibility = {}) => {
    const {
        autoPilotVisible = true,
        liveAlignVisible = true,
    } = stealthVisibility;
    // MazorX , powerease and stealth check
    const mazorCheck = items?.every((item) =>
        item.description === 'MazorX Robot Used' && item.isSelected
            ? item.mazorKitCode?.length > 0 &&
              item.mazorCaseCoverage &&
              item.mazorCaseCoverage !== '' &&
              item.mazorCaseCoverage !== 'undefined'
            : typeof item.isSelected === 'boolean'
    );
    // Updated Stealth AXiS validation: only validate selected object
    const stealthAxisObj = items?.find(
        (item) => item.description === 'Stealth AXiS' && item.isSelected
    );
    const stealthAxisCheck = stealthAxisObj
        ? stealthAxisObj.stealthAxisCode?.length > 5 &&
          stealthAxisObj.stealthCaseCoverage &&
          stealthAxisObj.stealthCaseCoverage !== '' &&
          stealthAxisObj.stealthCaseCoverage !== 'undefined' &&
          (autoPilotVisible ? typeof stealthAxisObj.stealthAxisAutoPilot === 'boolean' : true) &&
          (liveAlignVisible ? typeof stealthAxisObj.stealthAxisLiveAlign === 'boolean' : true)
        : true;

    // Advanced Energy check
    const advEnergySelected = items.filter(
        (item) => item.description === 'Advanced Energy' && item.isSelected
    );
    const advEnergyUnselected = items.filter(
        (item) =>
            item.description === 'Advanced Energy' &&
            typeof item.isSelected === 'boolean' &&
            !item.isSelected
    );

    let advEnergyValid = false;

    if (advEnergySelected.length > 0) {
        const advObj = advEnergySelected[0].advancedEnergyProduct;
        if (advObj && typeof advObj === 'object') {
            advEnergyValid =
                Object.values(advObj).filter((v) => v === true).length > 0;
        }
    } else if (advEnergyUnselected.length > 0) {
        advEnergyValid = true;
    } else {
        advEnergyValid = true;
    }

    return mazorCheck && stealthAxisCheck && advEnergyValid;
};

const getAdditionalProcedureObj = (
    additionalProcedureData,
    advancedEnergyProduct
) => { 
    const additionalProcedureObj = {};
    let adEnergyVal = {};
    if (
        typeof additionalProcedureData.find(
            (x) => x.description === 'Powerease'
        )?.isSelected === 'boolean'
    ) {
        additionalProcedureObj.isPowerease = additionalProcedureData.find(
            (x) => x.description === 'Powerease'
        )?.isSelected;
    }
    const mazorxRobotics = additionalProcedureData.find(
        (x) => x.description === 'MazorX Robot Used'
    );
    if (
        mazorxRobotics !== undefined &&
        typeof mazorxRobotics.isSelected === 'boolean'
    ) {
        additionalProcedureObj.isMazorXRoboticsUsed = mazorxRobotics.isSelected;
        if (mazorxRobotics.isSelected)
            additionalProcedureObj.mazorKitCode = mazorxRobotics.mazorKitCode
                ? mazorxRobotics.mazorKitCode
                : '';
        additionalProcedureObj.mazorCaseCoverage =
            mazorxRobotics.mazorCaseCoverage
                ? mazorxRobotics.mazorCaseCoverage
                : '';
    }
    const stealthAXIS = additionalProcedureData.find(
        (x) => x.description === 'Stealth AXiS'
    );
    if (
        stealthAXIS !== undefined &&
        typeof stealthAXIS.isSelected === 'boolean'
    ) {
        additionalProcedureObj.isStealthAxis = stealthAXIS.isSelected;
        if (stealthAXIS.isSelected)
            additionalProcedureObj.stealthAxisCode = stealthAXIS.stealthAxisCode
                ? stealthAXIS.stealthAxisCode
                : '';
        additionalProcedureObj.stealthAxisCaseCoverage =
            stealthAXIS.stealthCaseCoverage
                ? stealthAXIS.stealthCaseCoverage
                : '';

        if (
            stealthAXIS.isSelected &&
            typeof stealthAXIS.stealthAxisAutoPilot === 'boolean'
        ) {
            additionalProcedureObj.stealthAxisAutoPilot =
                stealthAXIS.stealthAxisAutoPilot;
        }
        if (
            stealthAXIS.isSelected &&
            typeof stealthAXIS.stealthAxisLiveAlign === 'boolean'
        ) {
            additionalProcedureObj.stealthAxisLiveAlign =
                stealthAXIS.stealthAxisLiveAlign;
        }
    }
    if (
        typeof additionalProcedureData.find(
            (x) => x.description === 'Stealth S7/S8 Navigation'
        )?.isSelected === 'boolean'
    ) {
        additionalProcedureObj.isNavigaton = additionalProcedureData.find(
            (x) => x.description === 'Stealth S7/S8 Navigation'
        )?.isSelected;
    }
    if (
        typeof additionalProcedureData.find(
            (x) => x.description === 'Advanced Energy'
        )?.isSelected === 'boolean'
    ) {
        additionalProcedureObj.isAdvancedEnergy = additionalProcedureData.find(
            (x) => x.description === 'Advanced Energy'
        ).isSelected;
        adEnergyVal = additionalProcedureData.find(
            (x) => x.description === 'Advanced Energy'
        ).advancedEnergyProduct;
        if (
            adEnergyVal &&
            additionalProcedureObj.isAdvancedEnergy &&
            advancedEnergyProduct
        ) {
            let objKey = Object.keys(adEnergyVal);
            objKey.map((pr) => {
                // pr = 'is'+pr;
                let ind = advancedEnergyProduct.findIndex(
                    (ind) => ind.description === pr
                );
                if (ind >= 0) {
                    adEnergyVal[pr] = advancedEnergyProduct[ind].isSelected;
                }
            });
            additionalProcedureObj.advancedEnergyProduct = adEnergyVal;
        }
    }
    return additionalProcedureObj;
};

export const createProcedureDraftOrderObject = (
    procedureData,
    advancedEnergyProduct,
    retractorUsedOtherFieldValue,
    uivArray,
    livArray,
    totalLevelsNumber
) => {
    const procedureObj = {};
    if (
        procedureData.additionalProcedure &&
        procedureData.additionalProcedure[0] !== 'ADDITIONAL_PROCEDURE_DATA' &&
        procedureData.additionalProcedure.some(
            (x) => typeof x.isSelected === 'boolean'
        ) &&
        Object.keys(
            getAdditionalProcedureObj(procedureData.additionalProcedure)
        ).length > 0
    ) {
        procedureObj.additionProcedure = getAdditionalProcedureObj(
            procedureData.additionalProcedure,
            advancedEnergyProduct
        );
    }
    if (
        procedureData.therapies &&
        procedureData.therapies.some((x) => x.isSelected)
    ) {
        procedureObj.physicianFinderEligibility = procedureData.therapies
            .filter((x) => x.isSelected)
            .map((y) => y.code);
    }

    if (
        procedureData.retractors &&
        procedureData.retractors.some((x) => x.isSelected)
    ) {
        procedureObj.usedRetractors = procedureData.retractors
            .filter((x) => x.isSelected)
            .map((y) => y.code);
        if (retractorUsedOtherFieldValue?.length > 0) {
            procedureObj.otherRetractor = retractorUsedOtherFieldValue;
        }
    }

    if (procedureData.levels || procedureData.levelsData) {
        if (uivArray?.length > 0 && livArray?.length > 0) {
            procedureObj.levelUsed = totalLevelsNumber;
            procedureObj.usedUIV = uivArray;
            procedureObj.usedLIV = livArray;
        }
    }
    if (procedureData.technologies) {
        const selectedTechnology = procedureData.technologies.find(
            (x) => x.isSelected
        );
        if (selectedTechnology) {
            procedureObj.deformityCorrectionCode = selectedTechnology.code;
        }
    }
    if (
        procedureData.biologicsUsed &&
        procedureData.biologicsUsed.some((x) => x.isSelected)
    ) {
        procedureObj.biologicsUsed = procedureData.biologicsUsed
            .filter((x) => x.isSelected)
            .map((y) => y.code);

        if (
            procedureData.biologicsDetail &&
            procedureData.biologicsUsed.find((x) => x.code === '02')?.isSelected
        ) {
            if (
                procedureData.biologicsDetail.some((x) => x.isMedtronicSelected)
            ) {
                procedureObj.medtronicSupp = procedureData.biologicsDetail
                    .filter((x) => x.isMedtronicSelected)
                    .map((y) => y.code);
            }
            if (
                procedureData.biologicsDetail.some(
                    (x) => x.isCompetitiveSelected
                )
            ) {
                procedureObj.compatitiveSupp = procedureData.biologicsDetail
                    .filter((x) => x.isCompetitiveSelected)
                    .map((y) => y.code);
            }
        }
    }
    return procedureObj;
};

export const generateUnidInfoRequestObject = (
    unidSurgeryInfo,
    cancelReason
) => {
    const unidSurgeryInfoObject = {};
    if (cancelReason?.optionId == 'UNID_NON_USE') {
        unidSurgeryInfoObject.detailReasontext = unidSurgeryInfo.reasonText;
        unidSurgeryInfoObject.detailReasonId =
            unidSurgeryInfo.whyAllRodsNotImplanted.find(
                (item) => item.isChecked
            ).reasonId;
        unidSurgeryInfoObject.unidPlanRef =
            'UH_' || 'AH_' + cancelReason?.unidId;
    } else {
        let updatedUnidProducts = [];
        unidSurgeryInfo?.unidProducts?.map((data) => {
            if (data.productCFN !== 'None') {
                let modifiedUnidProducts = {};
                modifiedUnidProducts.unidCounter = Number(data.unidCounter);
                modifiedUnidProducts.unidLineNumber = `${data.unidLineNumber}`;
                modifiedUnidProducts.parentUniqueLineNumber = `${data.parentLineNumber}`;
                modifiedUnidProducts.unidRodCFN = data.productCFN;
                modifiedUnidProducts.productDesc = data.description;
                modifiedUnidProducts.rodImplanted = data.isChecked
                    ? true
                    : false;
                modifiedUnidProducts.rodEtching = data?.rodEtching
                    ? data?.rodEtching
                    : '';
                modifiedUnidProducts.isMainRod =
                    data.implantedAsMainRod === 'Yes' ? true : false;
                modifiedUnidProducts.isRodSurgeonChangedSurgicalPlan =
                    !unidSurgeryInfo.mainRodCount > 0 &&
                    data.whyNotImplantedAsMainRod.find((item) => item.id === 1)
                        .isChecked;
                modifiedUnidProducts.isRodIssueWithLengthOrContour =
                    !unidSurgeryInfo.mainRodCount > 0 &&
                    data.whyNotImplantedAsMainRod.find((item) => item.id === 2)
                        .isChecked;
                updatedUnidProducts.push(modifiedUnidProducts);
                // data.implantedAsMainRod!==null ? updatedUnidProducts.push(modifiedUnidProducts) : null;
            }
        });

        unidSurgeryInfoObject.unidImplanteditems = updatedUnidProducts;

        const unidItems = unidSurgeryInfo?.unidProducts?.filter(
            (item) => item?.productCFN !== 'None' && item?.isChecked
        );

        unidSurgeryInfoObject.items = unidItems
            ? unidItems.map((x) => x.productCFN)
            : [];

        unidSurgeryInfoObject.hasMainRod = unidItems?.some(
            (item) => item.implantedAsMainRod == 'Yes'
        );

        unidSurgeryInfoObject.isSurgeonChangedSurgicalPlan =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 1
            ).isChecked;

        unidSurgeryInfoObject.isIssueWithLengthOrContour =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 2
            ).isChecked;

        unidSurgeryInfoObject.isSalesOperations =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 3
            ).isChecked;
        unidSurgeryInfoObject.salesOperationsText =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 3
            ).isChecked
                ? unidSurgeryInfo.reasonText
                : '';

        unidSurgeryInfoObject.isManufacturingIssue =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 4
            ).isChecked;
        unidSurgeryInfoObject.manufacturingIssueText =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 4
            ).isChecked
                ? unidSurgeryInfo.reasonText
                : '';

        unidSurgeryInfoObject.isNotDeliveredOnTime =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 5
            ).isChecked;

        unidSurgeryInfoObject.isMultipleVersions =
            unidSurgeryInfo?.whyAllRodsNotImplanted?.find(
                (item) => item.id === 6
            ).isChecked;
    }
    unidSurgeryInfoObject.mpxr = unidSurgeryInfo.mPXR;

    return unidSurgeryInfoObject;
};

export const generateORreportRequestObject = (
    orReportQuestionsObj,
    usageDetails
) => {
    const ORreportRequestObject = {};
    if (typeof orReportQuestionsObj.isSurgicalPlanChanged === 'boolean') {
        ORreportRequestObject.isSurgicalPlanChanged =
            orReportQuestionsObj.isSurgicalPlanChanged;
    }
    if (
        typeof orReportQuestionsObj.isLevelOfInstrumentationChanged ===
        'boolean'
    ) {
        ORreportRequestObject.isLevelOfInstrumentationChanged =
            orReportQuestionsObj.isLevelOfInstrumentationChanged;
        if (orReportQuestionsObj.isLevelOfInstrumentationChanged) {
            ORreportRequestObject.uiv = orReportQuestionsObj.uiv;
            ORreportRequestObject.liv = orReportQuestionsObj.liv;
        }
    }
    if (
        typeof orReportQuestionsObj.isChangeToInterbodiesAndOrPSOs === 'boolean'
    ) {
        ORreportRequestObject.isChangeToInterbodiesAndOrPSOs =
            orReportQuestionsObj.isChangeToInterbodiesAndOrPSOs;
        if (orReportQuestionsObj.isChangeToInterbodiesAndOrPSOs) {
            ORreportRequestObject.anyChangeToInterbodiesAndOrPSOsTxt =
                orReportQuestionsObj.anyChangeToInterbodiesAndOrPSOsTxt;
        }
    }
    if (typeof orReportQuestionsObj.isSurgeonCutTheRod === 'boolean') {
        ORreportRequestObject.isSurgeonCutTheRod =
            orReportQuestionsObj.isSurgeonCutTheRod;
        if (orReportQuestionsObj.isSurgeonCutTheRod) {
            ORreportRequestObject.surgeonCutTheRodText =
                orReportQuestionsObj.surgeonCutTheRodText;
        }
    }
    if (typeof orReportQuestionsObj.isRodBentInSagittalPlan === 'boolean') {
        ORreportRequestObject.isRodBentInSagittalPlan =
            orReportQuestionsObj.isRodBentInSagittalPlan;
        if (orReportQuestionsObj.isRodBentInSagittalPlan) {
            ORreportRequestObject.rodBentInSagittalPlanTxt =
                orReportQuestionsObj.rodBentInSagittalPlanTxt;
        }
    }
    if (typeof orReportQuestionsObj.isSurgeonSatisfied === 'boolean') {
        ORreportRequestObject.isSurgeonSatisfied =
            orReportQuestionsObj.isSurgeonSatisfied;
    }
    if (
        typeof orReportQuestionsObj.pjkPerformed === 'boolean' &&
        usageDetails?.ispjkOrder === 'Y'
    ) {
        ORreportRequestObject.pjkPerformed = orReportQuestionsObj.pjkPerformed;
    }
    if (typeof orReportQuestionsObj.pjkMdtInstructed === 'boolean') {
        ORreportRequestObject.pjkMdtInstructed =
            orReportQuestionsObj.pjkMdtInstructed;
    }
    if (typeof orReportQuestionsObj.pjkMdtImplants === 'boolean') {
        ORreportRequestObject.pjkMdtImplants =
            orReportQuestionsObj.pjkMdtImplants;
    }
    return ORreportRequestObject;
};

export const createReportPaymentSubmissionProductsArr = (
    reportPaymentGridData,
    formObjectProduct,
    resourceType
) => {
    let entryNum = 0;
    return reportPaymentGridData?.length > 0
        ? reportPaymentGridData.map((item) => {
              let newObject = {};
              if (item.isAdditionalCartEntry) {
                  newObject = {
                      isAdditionalCartEntry: item.isAdditionalCartEntry,
                      isReplenish: item.isReplenish ? item.isReplenish : false,
                      productCFN: item.productCFN,
                      salesOrg: item.salesOrg,
                      isAccountOwned: false,
                      lotSerialUnknown: item?.lotSerialUnknown,
                  };
                  if (item.scannedGTIN) {
                      newObject.scannedGTIN = item.scannedGTIN;
                  }
                  if (item.description) {
                      newObject.description = item.description;
                  }
                  if (item.lotSerialNumber) {
                      newObject.lotSerialNumber = item.lotSerialNumber;
                  }
                  if (item?.bundleItem?.length > 0) {
                      newObject.bundleItem = item.bundleItem;
                      newObject.isBundleHeader = true;
                  }
                  if (item?.bundleHeaderPosition >= 0) {
                      newObject.bundleHeaderPosition =
                          item.bundleHeaderPosition;
                  }
                  if (item?.replenishmentDetails) {
                      newObject.replenishmentDetails =
                          item.replenishmentDetails;
                  }
                  newObject.isReplenish = item.isReplenish
                      ? item.isReplenish
                      : false;

                  if (item.unitPrice) {
                      newObject.unitPrice = getPriceInNumberDataType(
                          item.unitPrice
                      ).toFixed(2);
                  }
                  if (item.uom) {
                      newObject.uom = item.uom;
                  }
                  if (item.usedQuantity) {
                      newObject.usedQuantity = isNaN(
                          parseInt(item.usedQuantity)
                      )
                          ? item.usedQuantity
                              ? '1'
                              : '0'
                          : item.usedQuantity;
                  }
                  if (resourceType === 'reportPayment') {
                      newObject.entryNum = entryNum.toString();
                      entryNum = entryNum + 1;
                  }
                  const overrideUnitPrice = item.usedQuantity
                      ? item.adjustedUsedQtyPrice
                      : item.adjustedOtherQtyPrice;
                  if (overrideUnitPrice) {
                      newObject.overrideUnitPrice = overrideUnitPrice
                          ?.toString()
                          .replace('$', '')
                          .replaceAll(',', '');
                      newObject.isPriceUpdated = item.isPriceOverrideDoneInUsage
                          ? getPriceInNumberDataType(item.overriddenPrice) !==
                            getPriceInNumberDataType(overrideUnitPrice)
                          : true;
                  } else {
                      newObject.overrideUnitPrice =
                          item.isPriceOverrideDoneInUsage
                              ? item.adjustedUsedQtyPrice === null ||
                                item.adjustedOtherQtyPrice === null
                                  ? undefined
                                  : item.overrideUnitPrice
                              : undefined;
                      newObject.isPriceUpdated = item.isPriceOverrideDoneInUsage
                          ? true
                          : false;
                  }
              } else {
                  const temp = formObjectProduct.filter((formObject) =>
                      resourceType === 'reportPayment'
                          ? formObject.entryNum === item.entryNum
                          : true &&
                            formObject.productCFN === item.productCFN &&
                            (item?.usedQuantity
                                ? formObject.usedQuantity === item.usedQuantity
                                : formObject.otherQuantity ===
                                  item.otherQuantity)
                  );
                  if (temp.length > 0) {
                      newObject = {
                          ...temp[0],
                          isAdditionalCartEntry: false,
                      };
                      const overrideUnitPrice = item.usedQuantity
                          ? item.adjustedUsedQtyPrice
                          : item.adjustedOtherQtyPrice;
                      if (overrideUnitPrice) {
                          newObject.overrideUnitPrice = overrideUnitPrice
                              ?.toString()
                              .replace('$', '')
                              .replaceAll(',', '');
                          newObject.isPriceUpdated =
                              item.isPriceOverrideDoneInUsage
                                  ? getPriceInNumberDataType(
                                        item.overriddenPrice
                                    ) !==
                                    getPriceInNumberDataType(overrideUnitPrice)
                                  : true;
                      } else {
                          newObject.overrideUnitPrice =
                              item.isPriceOverrideDoneInUsage
                                  ? item.adjustedUsedQtyPrice === null ||
                                    item.adjustedOtherQtyPrice === null
                                      ? undefined
                                      : item.overrideUnitPrice
                                  : undefined;
                          newObject.isPriceUpdated =
                              item.isPriceOverrideDoneInUsage ? true : false;
                      }
                  }
              }
              if (item.payment) {
                  newObject.payment = {
                      poNumber: item.payment.poNumber,
                  };
                  if (item.payment?.poAttachment) {
                      newObject.payment = {
                          ...newObject.payment,
                          poAttachment: item.payment.poAttachment,
                      };
                  }
              } else {
                  delete newObject.payment;
              }
              return newObject;
          })
        : [];
};
export const toggleSaveExitButton = (
    filterProduct,
    isUsage = false,
    isErrorFoundInProcedure,
    isErrorFoundInFirstLevel,
    currentActivity,
    countryCode,
    countryISOCode,
    isMandatoryPhysicianMissing = false
) => {
    let disableBtn =
        currentActivity === 'Procedure' && isMandatoryPhysicianMissing;
    if(filterProduct?.length <= 0){
        disableBtn = true;
    }
    filterProduct.forEach((item) => {
        if (!item.salesOrg || item.salesOrg == '') {
            disableBtn = true;
        }

        if (item.isBundleItem && isUsage) {
            if (!item.children || item.children.length < 1) {
                disableBtn = true;
            }
            item.children?.forEach((bitem) => {
                if (!bitem.salesOrg || bitem.salesOrg === '') {
                    disableBtn = true;
                }
            });
        }
        if (
            currentActivity === 'Procedure' &&
            (countryCode === 'US') &&
                (isErrorFoundInProcedure || isErrorFoundInFirstLevel)
        ) {
            disableBtn = true;
        }
    });
    return disableBtn;
};

// {
//     "description" : "CASE 105-123 POST",
//     "entryNum" : "7",
//     "isAccountOwned" : false,
//     "isAdditionalCartEntry" : false,
//     "isBundleHeader" : false,
//     "isDeleteButtonPresent" : true,
//     "otherQuantity" : "1",
//     "overrideUnitPrice" : "12.0",
//     "payment" : {
//     },
//     "productCFN" : "105-123",
//     "reason" : "WASTE",
//     "salesOrg" : "S002",
//     "unitPrice" : "23.0",
//     "uom" : "EA"
//  }
export const priceOverrideData = (itemTableData) => {
    return (
        itemTableData &&
        (itemTableData || []).map((item) => {
            const otherExtPrice = item.otherQuantity
                ? getTotalExtendedPriceRP(
                      item.unitPrice,
                      parseInt(item.otherQuantity),
                      'other'
                  )
                : null;
            const usedExtPrice = item.usedQuantity
                ? getTotalExtendedPriceRP(
                      item.unitPrice,
                      parseInt(item.usedQuantity),
                      'used'
                  )
                : null;
            const extPrice = getTotalExtendedPriceRP(
                item.unitPrice,
                parseInt(item.usedQuantity || 0) +
                    parseInt(item.otherQuantity || 0),
                'used'
            );
            const adjOtherExtPrice =
                item.otherQuantity && item.overrideUnitPrice
                    ? getTotalExtendedPriceRP(
                          item.overrideUnitPrice,
                          parseInt(item.otherQuantity),
                          'other'
                      )
                    : null;
            const adjUsedExtPrice =
                item.usedQuantity && item.overrideUnitPrice
                    ? getTotalExtendedPriceRP(
                          item.overrideUnitPrice,
                          parseInt(item.usedQuantity),
                          'used'
                      )
                    : null;
            const adjExtPrice = item.overrideUnitPrice
                ? getPriceInNumberDataType(
                      getTotalExtendedPriceRP(
                          item.overrideUnitPrice,
                          parseInt(item.usedQuantity || 0) +
                              parseInt(item.otherQuantity || 0),
                          'used'
                      )
                  )
                : null;
            const parsedPrice = getPriceInNumberDataType(item.unitPrice);
            const obj = {
                ...item,
                basePrice: parsedPrice != null && priceFormatObj.currency
                    ? parsedPrice.toLocaleString('en-US', priceFormatObj)
                    : parsedPrice?.toFixed(priceFormatObj.minimumFractionDigits || 2),
                cfn: item.productCFN,
                lotSerial: [
                    {
                        Serial: '',
                        used: item.usedQuantity ? item.usedQuantity : false,
                        other: item.otherQuantity ? item.otherQuantity : false,
                    },
                ],
                 isOverrideApplied: 
            (item.adjustedUsedQtyPrice || item.adjustedOtherQtyPrice||item.overrideUnitPrice) && true,
        overridenUnitPriceApplied:
            (item.adjustedUsedQtyPrice || item.adjustedOtherQtyPrice) &&
            item.overridenUnitPriceApplied &&
            true,
    
                accountOwned: item.isAccountOwned,
                extPrice: extPrice,
                usedQtyExtPrice: usedExtPrice,
                otherQtyExtPrice: otherExtPrice,
                adjustedUsedQtyPrice:
                    item.usedQuantity && item.overrideUnitPrice,
                adjustedUsedQtyExtPrice: adjUsedExtPrice,
                adjustedOtherQtyPrice:
                    item.otherQuantity && item.overrideUnitPrice,
                adjustedOtherQtyExtPrice: adjOtherExtPrice,
                adjustedExtPrice: adjExtPrice,
            };
            return obj;
        })
    );
};

export const displayCheckbox = (item) => item.showCheckBox;

/**
 * Determines if the operation should be a create (POST) vs update (PUT).
 * Resource type takes precedence over order status to prevent stale status
 * from triggering an incorrect create when an order already exists.
 */
export const isCreateOperation = (myCaseResourceType, orderStatusDescription, t) => {
    // Prefer explicit route/context resource type first.
    if (myCaseResourceType === 'draft') {
        return false;
    }
    if (myCaseResourceType === 'reportPayment') {
        return false;
    }
    if (myCaseResourceType === 'reportUsage') {
        return true;
    }

    // Fallback to order status when resource type is missing/unknown.
    const isDraftNotSubmitted =
        orderStatusDescription === t('orders.orderStatuses.draftNotSubmitted');
    const isUsagePending =
        orderStatusDescription === t('orders.orderStatuses.usagePending');

    if (isDraftNotSubmitted) {
        return false;
    }
    if (isUsagePending) {
        return true;
    }

    return false;
};
